import { render, staticRenderFns } from "./studentList.vue?vue&type=template&id=03206b76&scoped=true&"
import script from "./studentList.vue?vue&type=script&lang=ts&"
export * from "./studentList.vue?vue&type=script&lang=ts&"
import style0 from "./studentList.vue?vue&type=style&index=0&id=03206b76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03206b76",
  null
  
)

export default component.exports